import React, { useEffect, useState } from "react";

/**
 * DeviceInspector
 * - Shows all data received from WPF WebView2
 * - Auto-opens on app launch
 * - Saves device context to localStorage
 * - Ctrl + D toggles modal
 */
export default function DeviceInspector() {
  const [open, setOpen] = useState(false);
  const [payload, setPayload] = useState(null);

  useEffect(() => {
    const isDesktopApp = !!window.chrome?.webview;
    // ✅ Fix: Check if running on localhost (works for both CRA and Vite)
    const isLocalDev =
      window.location.hostname === "localhost" ||
      window.location.hostname === "127.0.0.1" ||
      window.location.hostname === "";

    const handleDevicePayload = (data) => {
      console.log("📡 Device payload received:", data);

      setPayload(data);
      setOpen(true); // 🔥 auto open on launch

      if (data?.orgDevice) {
        localStorage.setItem("macId", data.MacId);
        localStorage.setItem("ipAddress", data.IpAddress);
        localStorage.setItem("deviceContext", JSON.stringify(data.orgDevice));
        localStorage.setItem("deviceCode", data.orgDevice.deviceCode);
        localStorage.setItem("orgCode", data.orgDevice.orgCode);
      }
    };

    if (isDesktopApp) {
      const handler = (event) => handleDevicePayload(event.data);
      window.chrome.webview.addEventListener("message", handler);

      return () =>
        window.chrome.webview.removeEventListener("message", handler);
    }

    if (isLocalDev) {
      handleDevicePayload({
        IpAddress: "192.168.1.192",
        MacId: "509A4C0C41D3",
        orgDevice: {
          deviceCode: "LOCAL-DANFE-MAN-TOUCH",
          orgCode: "DEM105",
          deviceName: "Danfe Touch (Local)",
          organizationId: 1,
          terminal: "terminal1",
          showHeartBeatWindow: false,
        },
      });
    }
  }, []);

  // Ctrl + D toggle
  useEffect(() => {
    const toggle = (e) => {
      if (e.ctrlKey && e.key.toLowerCase() === "d") {
        setOpen((v) => !v);
      }
    };
    window.addEventListener("keydown", toggle);
    return () => window.removeEventListener("keydown", toggle);
  }, []);

  if (!open || !payload) return null;

  // return (
  //   <div style={styles.backdrop}>
  //     <div style={styles.modal}>
  //       <div style={styles.header}>
  //         <h3>📡 Device Inspector</h3>
  //         <button style={styles.closeBtn} onClick={() => setOpen(false)}>
  //           ✖
  //         </button>
  //       </div>

  //       <div style={styles.body}>
  //         <pre style={styles.pre}>
  //           {JSON.stringify(payload, null, 2)}
  //         </pre>
  //       </div>

  //       <div style={styles.footer}>
  //         <span>Ctrl + D to toggle</span>
  //       </div>
  //     </div>
  //   </div>
  // );
}

const styles = {
  backdrop: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.65)",
    zIndex: 99999,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  modal: {
    background: "#0b0b0b",
    color: "#00ff9c",
    width: "85%",
    maxWidth: 900,
    maxHeight: "85vh",
    borderRadius: 8,
    display: "flex",
    flexDirection: "column",
    boxShadow: "0 0 25px rgba(0,255,156,0.35)",
  },
  header: {
    padding: "10px 14px",
    borderBottom: "1px solid #1f1f1f",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  body: {
    padding: 12,
    overflow: "auto",
    flex: 1,
  },
  footer: {
    padding: 8,
    fontSize: 11,
    textAlign: "center",
    borderTop: "1px solid #1f1f1f",
    opacity: 0.7,
  },
  closeBtn: {
    background: "transparent",
    border: "none",
    color: "#fff",
    cursor: "pointer",
    fontSize: 16,
  },
  pre: {
    margin: 0,
    fontSize: 12,
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
  },
};
